module.exports = __webpack_public_path__ + "static/media/phone.f427581a.svg";